module.exports = __webpack_public_path__ + "static/media/profile.f71074b9.svg";